import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';
import moment from 'moment-timezone';

export default Factory.extend({
  delinquent: false,
  resellerPartner: false,
  isAchTransfer: false,

  creditBalance() {
    return faker.number.int();
  },

  trialEnd() {
    return {
      deliveries: null,
      rooms: moment().add(5, 'days').utc(),
      visitors: moment().add(5, 'days').utc(),
    };
  },
});
